import { PostJsonTyped, PostJson } from "../ApiUtils";

const API_URL = "/api/TaskInfo/";

export function GetTaskStatus(taskId:string) {
    return PostJsonTyped<ITaskStatusDTO>(API_URL + "GetTaskStatus", taskId);
}

export function GetTaskCardInfo(taskId: string) {
    return PostJsonTyped<ITaskCardInfoDTO>(API_URL + "GetTaskCardInfo", taskId);
}